import { render, staticRenderFns } from "./ZhiNanGjj.vue?vue&type=template&id=608c9742&scoped=true&"
import script from "./ZhiNanGjj.vue?vue&type=script&lang=js&"
export * from "./ZhiNanGjj.vue?vue&type=script&lang=js&"
import style0 from "./ZhiNanGjj.vue?vue&type=style&index=0&id=608c9742&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c9742",
  null
  
)

export default component.exports